module.exports = __webpack_public_path__ + "img/revoke.44206556.png";